import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import config from "../functions/config";
import { Link } from "react-router-dom";

function PaymentPage() {
  const navigate = useNavigate();
  const { rentalId } = useParams(); // Extract rentalId from the URL
  const [rentalDetails, setRentalDetails] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false); // State for confirmation checkbox
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  // Fetch Rental Details
  useEffect(() => {
    const fetchRentalDetails = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/lost/${rentalId}/`);
        setRentalDetails(response.data);
        console.log(response.data);  // ✅ Corrected console.log
      } catch (error) {
        console.error("Error fetching rental details:", error);
      }
    };
    
    if (rentalId) {
      fetchRentalDetails();
    }
  }, [rentalId]);
  console.log("Book Image URL:", rentalDetails?.book?.image);

  // Handle Payment Function
  const handlePayment = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-lost/${rentalId}/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: "lost",
        }),
      });

      if (response.ok) {
        alert("Mark as losted!");
        navigate("/rentalhistory");
      } else {
        alert("Failed to mark as lost.");
      }
    } catch (error) {
      console.error("Error processing lost:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      {/* Navbar */}
    {/* Navbar */}
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      <div className="container mt-5 pt-5">
  <h2 className="text-center my-4">Book Details And Action</h2>

  <div className="row">
    {/* Left Section: Book Image & Details */}
    <div className="col-md-6 d-flex">
      {/* Book Image */}
      {rentalDetails?.book?.image && (
        <img
          src={rentalDetails.book.image ? `${config.BASE_URL}${rentalDetails.book.image}` : "https://via.placeholder.com/150"} 
          alt={rentalDetails.book.title || "Book Cover"} 
          className="img-fluid img-thumbnail"
          style={{
            width: '190px',
            height: '260px',
            objectFit: 'cover',
            borderRadius: '10px',
            border: '2px solid #ddd',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            marginRight: '20px',
          }}
          onError={(e) => (e.target.src = "https://via.placeholder.com/150")}
        />
      )}

      {/* Book Details */}
      <div>
        <h4>{rentalDetails?.book?.title}</h4>
        <p><strong>Author:</strong> {rentalDetails?.book?.author}</p>

        <p><strong>Publisher:</strong> {rentalDetails?.book?.publisher}</p>
        {/* <p><strong>Rent Date:</strong> {rentalDetails?.rent_date}</p> */}
        {/* <p><strong>Return Date:</strong> {rentalDetails?.return_date || "Not returned yet"}</p> */}
        <p><strong>Total Price:</strong> {rentalDetails?.book?.total_price}</p>
        <p><strong>Amout due:</strong> ₹{rentalDetails?.amount_due}</p>

      </div>
    </div>

    {/* Right Section: GPay Payment Card */}
    <div className="col-md-5">
  <div className=" text-center p-5">
    <div className="card-body">
      <h5 className="card-title">Damage Action</h5>
      <p className="card-text">If the book is damaged you should ..<button className="btn text-danger">Terms and Conditions</button></p>

      {/* Confirmation Checkbox */}
      <div className="form-check mb-3">
        <input
        
          type="checkbox"
          className="form-check-input"
          id="confirmCheckbox"
          checked={isConfirmed}
          onChange={() => setIsConfirmed(!isConfirmed)}
        />
        <label className="form-check-label" htmlFor="confirmCheckbox">
        "I confirm that the book is damaged and I agree to pay the total amount, including the book price and an additional fine."        </label>
      </div>

      {/* Payment Button (Disabled until checkbox is checked) */}
      <button
        className="btn btn-primary"
        onClick={handlePayment}
        disabled={!isConfirmed} // Button disabled unless checkbox is checked
      >
        Mark as Lost
      </button>
    </div>
  </div>
</div>

  </div>
</div>

    </div>
  );
}

export default PaymentPage;
